<template>
  <router-view/>
</template>

<style lang="scss">
*{
  padding: 0;
  margin: 0;
}
</style>
<style  rel="stylesheet/scss">
@font-face {
  font-family: "DINOffcPro";
  src: url('https://xjyos.xijiuyou.com/conchgame/app/DINOffcPro-Bold.ttf');
  font-weight: normal;
  font-style: normal;
}
</style>
